import React, { FC } from 'react'
import { ComponentFeaturedAsset } from '../../../models/components/featuredAsset'
import ImgUtil from '../../../utils/img.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

import Button from '../button'
import Typography from '../typography'

import VideoCta from '../videoCta/videoCta'
import VideoPlayer from '../videoPlayer'
import { FeaturedAssetContainer } from './style'

type Props = {
  data: ComponentFeaturedAsset
}

export const FeaturedAsset: FC<Props> = ({ data }) => {
  const featuredAssetData = {
    title: data?.title || '',
    body: data?.body || data?.description || '',
    imageUrl: data?.image?.image?.file?.url || '',
    imgAlt: data?.image?.altText || '',
    category: data?.category?.title || data?.eyebrow,
    ctaUrl: data?.url1 || data?.ctaLink,
    ctaText: data?.ctaText,
    microcopyset: data?.microcopy || [],
    video: {
      image: data.video?.image?.file?.url || '',
      altText: data.video?.altText || '',
      start: data.video?.start || '',
      animationFile: data.video?.animationFile?.file?.url || '',
      url: '',
      id: '',
      type: '',
      imageOverlay: data.video?.imageOverlay || '',
    },
  }

  if (data.video?.youtubeId) {
    featuredAssetData.video.id = data.video.youtubeId
    featuredAssetData.video.type = 'youtube'
  }

  if (data.video?.vimeoId) {
    featuredAssetData.video.id = data.video.vimeoId
    featuredAssetData.video.type = 'vimeo'
  }

  if (data.video?.videoUrl) {
    featuredAssetData.video.url = data.video.videoUrl
    featuredAssetData.video.type = 'html-video'
  }

  if (data.video?.tencentVideoUrl) {
    featuredAssetData.video.url = data.video.tencentVideoUrl
    featuredAssetData.video.type = 'tencent-video'
  }

  const videoOverlayData = {
    imageUrl: featuredAssetData?.imageUrl,
    imgAlt: featuredAssetData?.imgAlt,
    video: featuredAssetData?.video,
  }

  const renderVideoOverlay = (videoData: any) => {
    return (
      <VideoPlayer
        width={'100%'}
        height="auto"
        videoId={videoData.video.id}
        videoUrl={videoData.video.url}
        type={videoData.video.type}
        img={videoData.imageUrl ? videoData.imageUrl : videoData.video.image}
        backgroundAltText={videoData?.video?.altText}
        backgroundImgParams={'width=732'}
        start={videoData.video.start}
        animationFileUrl={videoData.video.animationFile}
        imageOverlay={videoData.video.imageOverlay}
      />
    )
  }

  return (
    <FeaturedAssetContainer className="FeaturedAsset">
      <div className="absolute">
        {featuredAssetData.imageUrl && (
          <div className="FeaturedAsset__Image-Container">
            {data.video ? (
              <div className="FeaturedAsset__Video">{renderVideoOverlay(videoOverlayData)}</div>
            ) : (
              <img
                className="FeaturedAsset__Image"
                src={ImgUtil.getResizedImageUrl(featuredAssetData.imageUrl, 'width=430')}
                alt={featuredAssetData.imgAlt}
              />
            )}
          </div>
        )}

        <div className="FeaturedAsset__Text-Container">
          <div className="TopSection">
            <div className="FeaturedAsset__Type">{featuredAssetData.category}</div>
            <Typography className="FeaturedAsset__Title" type="header6">
              {formatInlineCode(featuredAssetData.title)}
            </Typography>
            {featuredAssetData.body && (
              <div className="FeaturedAsset__Desc">{renderRichText(featuredAssetData?.body)}</div>
            )}
          </div>
          <div className="BottomSection">
            <div className="FeaturedAsset__CtaBox">
              {data.video ? (
                <VideoCta
                  width={'100%'}
                  height="auto"
                  videoId={videoOverlayData.video.id}
                  videoUrl={videoOverlayData.video.url}
                  type={videoOverlayData.video.type}
                  ctaText={''}
                  ctaType="primary"
                  ctaTheme={'light'}
                  ctaSize={'small'}
                />
              ) : (
                <Button
                  icon={true}
                  href={featuredAssetData.ctaUrl}
                  text={``}
                  type="primary"
                  size="small"
                  theme={'light'}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </FeaturedAssetContainer>
  )
}
